import Autocomplete from "@material-ui/lab/Autocomplete";
/* core components */
import React from "react";
import TextField from "@material-ui/core/TextField";
import { Validate } from "utils/Validators/Validate";
import conf from "config/env.conf.js";
import getDefaultValue from "utils/DefaultValue";
/* custom components */
import useFetch from "hooks/useFetch";

const ListboxInspectVoteDate = props => {
  const [helperText] = React.useState("");

  const [valid, setValid] = React.useState();
  const [isLoading, fetchData] = useFetch(
    conf.END_POINT_URL + `/inspector/votedate`,
    []
  );

  const customVoteDate = old => {
    let d = new Date(old);
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric"
    };
    return d.toLocaleDateString("th-TH", options);
  };

  let content = (
    <TextField disabled label="วันเลือกตั้งในระบบ" margin="normal" fullWidth />
  );

  let data = [];

  if (!isLoading && fetchData !== null && fetchData.data !== undefined) {
    data = fetchData.data.map(v => {
      return {
        id: v.inspectorVotedateId,
        value: v.voteDate,
        key: v.inspectorPositionTypeId
      };
    });

    if (props.positionTypeId !== null) {
      data = data.filter(v => {
        return v.key == props.positionTypeId;
      });
    }
  }

  if (data.length > 0) {
    content = (
      <Autocomplete
        id="ListboxInspectVoteDate"
        disabled={props.disabled}
        defaultValue={getDefaultValue(data, props.defaultValue)}
        options={data}
        value={props.value}
        getOptionLabel={option => customVoteDate(option.value)}
        getOptionSelected={(option, value) => option.id === value.id}
        onChange={props.onChange}
        renderInput={params => {
          return (
            <TextField
              {...params}
              label="วันเลือกตั้งในระบบ"
              margin="normal"
              error={valid}
              fullWidth
              helperText={helperText}
              onChange={Validate(
                params.inputProps.value,
                props.required,
                setValid
              )}
              required={props.required}
            />
          );
        }}
      />
    );
  }
  return content;
};
export default ListboxInspectVoteDate;
